///////////////////////////////////////////////////////////////////////////////
/////////////// Supported Chains///////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
/** The current EVM chains Switchboard is currently deployed on. */
export const SWITCHBOARD_EVM_CHAINS = [
    'arbitrum',
    'base',
    'coredao',
    'ethereum',
    'optimism',
    'aurora',
];
/** The current chains Switchboard is currently deployed on. */
export const SWITCHBOARD_CHAINS = [
    'aptos',
    'near',
    'solana',
    'starknet',
    'sui',
    ...SWITCHBOARD_EVM_CHAINS,
];
///////////////////////////////////////////////////////////////////////////////
/////////////// Supported Chain IDs ///////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
export const SUPPORTED_EVM_CHAIN_IDS = [
    // arbitrum
    42161, 421613, 421614,
    // base
    8453, 84531,
    // core
    1116, 1115,
    // ethereum
    1, 5,
    // optimism
    10, 420,
    // aurora
    1313161554, 1313161555,
];
///////////////////////////////////////////////////////////////////////////////
/////////////// Supported Networks ////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
const EVM_SUPPPORTED_NETWORKS = ['mainnet', 'testnet'];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SUPPPORTED_NETWORKS = [...EVM_SUPPPORTED_NETWORKS, 'devnet'];
